import { Component, OnInit, Input, ElementRef, HostListener, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from 'src/app/services/reports/reports.service';
import { SweetAlertService } from 'src/app/services/sweetalert/sweet-alert.service';

@Component({
    selector: 'app-new-tag',
    templateUrl: './new-tag.component.html',
    styleUrls: ['./new-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewTagComponent implements OnInit {

  @Input() data: any;
  @Output() tagCreated = new EventEmitter<string>();
  newColor: string = 'primary';
  bgColor: string[] = ['primary', 'secondary', 'success', 'danger', 'warning', 'info'];
  showColors: boolean = false;
  loading: boolean = false;
  inputTagName: any;

  constructor(
    private activeModal: NgbActiveModal,
    private reportService: ReportsService,
    private sweetAlertService: SweetAlertService,
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.newTagName) {
      this.inputTagName = this.data.newTagName;
    }
  }

  closeModel() {
    this.activeModal.dismiss();
  }

   showAllColors() {
    this.showColors = !this.showColors;
  }

  selectcolorList(colorList: string) {
    this.newColor = colorList;
    this.showColors = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.showColors = false;
    }
  }

  createTags() {
    if (this.inputTagName !== '' && this.inputTagName !== undefined) {
      this.loading = true;
      const formData: any = new FormData();
      formData.append('tag_name', this.inputTagName);
      formData.append('tag_color', this.newColor);
      formData.append('create_tag', 'create_tag');
      this.reportService.getTagsCreate(formData).subscribe({
        next: (data) => {
          this.loading = false;
          if (data == "max_tags") {
            this.sweetAlertService.sweetAlert("error", " You can create upto 20 Tags only.");
          }
          else if (data == "available") {
            this.sweetAlertService.sweetAlert("error", "Tag name already used");
          }
          else if (data == "max_characters") {
            this.sweetAlertService.sweetAlert("error", "Maximum characters for tag name is 20");
          }
          else if (data == "error_in_insert") {
            this.sweetAlertService.sweetAlert("error", "Error in insert");
          }
          else if (data == "success") {
            this.sweetAlertService.sweetAlert("success", "Tag created successfully");
            this.tagCreated.emit(this.inputTagName);
            this.activeModal.close('success');
          }
        },
        error: () => {
          this.loading = false;
        }
      })
    }
    else {
      this.sweetAlertService.sweetAlert("error", "Please fill the field.");
    }
  }


}
